import { Box } from '@mui/system';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  DialogContentText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  Chip,
  TableRow,
  InputAdornment
} from '@mui/material';
// icons
import CloseIcon from '@mui/icons-material/Close';
import searchFill from '@iconify/icons-eva/search-fill';

import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { AiFillPrinter, AiOutlineFileText } from 'react-icons/ai';
import { CgPlayListAdd } from 'react-icons/cg';
import { GoFilePdf } from 'react-icons/go';
import { SiMicrosoftexcel } from 'react-icons/si';
import { TbFileSymlink } from 'react-icons/tb';
// react icons
import { BiCloudDownload, BiShareAlt } from 'react-icons/bi';
import { BsAspectRatio, BsTelephone } from 'react-icons/bs';
import { MdCheckBox, MdCreditScore, MdEmail, MdTextsms, MdUpdate } from 'react-icons/md';
import { RiFileInfoLine, RiPrinterCloudFill, RiWhatsappFill } from 'react-icons/ri';
import { Document, pdfjs, Page as Pages } from 'react-pdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import UpdateIcon from '@mui/icons-material/Update';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import InterestsIcon from '@mui/icons-material/Interests';
import CampaignIcon from '@mui/icons-material/Campaign';
import SourceIcon from '@mui/icons-material/Source';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DateRangeIcon from '@mui/icons-material/DateRange';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { FaRegUser } from 'react-icons/fa';
import { GiSwapBag, GiModernCity } from 'react-icons/gi';
import { HiOutlineMail } from 'react-icons/hi';
import { StyledTableCell, StyledTableRow, SearchStyle, pillTabsSx } from './Styling';
import Loader from './Loader';
import Scrollbar from '../../components/Scrollbar';
import profileImg from './profileImg.png';
import ViewCardComponent from '../../components/ViewCards';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import CustomDialog from '../../components/CustomDialogue';
import CustomInput from '../../components/CustomInput';
import CustomSelect from '../../components/CustomSelect';
import { getBankDropdownData, getMasterListType } from '../../store/Slice/Global/GlobalSlice';
import { transformToSelectOptions } from '../../utils/CommonFunction';
import {
  getLoginApproveProcess,
  getLoginUserProfile,
  getRecoRecommendedBank
} from '../../store/Slice/LoginModule/LoginModuleSlice';
import useLoginModuleSelector from '../../store/Slice/LoginModule/LoginModuleSelector';
import { getBranchRecordByBank } from '../../store/Slice/Lead/LeadSlice';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export const validationSchema = yup.object().shape({
  submittedToBankId: yup
    .string()
    .nullable()
    .required('Bank Name is required')
    .notOneOf(['', ' ', null], 'Please select a valid Bank'),

  submissionModeTypeId: yup
    .string()
    .nullable()
    .required('Mode of Submission is required')
    .notOneOf(['', ' ', null], 'Please select a valid Mode of Submission'),

  loginTypeId: yup
    .string()
    .nullable()
    .required('Login Type is required')
    .notOneOf(['', ' ', null], 'Please select a valid Login Type'),

  dsaLoginCode: yup
    .string()
    .nullable()
    .required('Login Code / DSA Code is required')
    .notOneOf(['', ' ', null], 'Please select a valid DSA Code'),

  processingCenterName: yup
    .string()
    .required('Processing Center is required')
    .max(100, 'Processing Center must be less than 100 characters'),

  bankContactPersonName: yup
    .string()
    .required('Bank Contact Person is required')
    .max(50, 'Contact Person name must be less than 50 characters'),

  bankContactPersonMobile: yup
    .string()
    .required('Contact Person Mobile is required')
    .matches(/^[6-9][0-9]{9}$/, 'Enter a valid 10-digit mobile number'),

  submissionComments: yup
    .string()
    .required('Comments are required')
    .max(500, 'Comments must be less than 500 characters')
});

const RECOMMENDED_BANK_CODES = [
  'HDFC',
  'ICICI',
  'SBI',
  'AXIS',
  'KOTAK',
  'PNB',
  'BANK_OF_BARODA',
  'IDFC',
  'BANDHAN',
  'UNION_BANK'
];
function BankLogo({ bankName }) {
  const [logoError, setLogoError] = useState(false);

  return logoError ? (
    <Box
      width={120}
      height={50}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        border: '1px solid #ddd',
        borderRadius: '6px',
        background: '#fafafa'
      }}
    >
      <Icon icon="mdi:bank-outline" width={28} height={28} />
    </Box>
  ) : (
    <Box
      width={120}
      height={50}
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        border: '1px solid #eee',
        borderRadius: '6px',
        background: '#fff'
      }}
    >
      <img
        alt={bankName}
        src={`../../static/bankLogo/${bankName?.toLowerCase()}_icon.png`}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain'
        }}
        onError={() => setLogoError(true)}
      />
    </Box>
  );
}

function ApplicationView({ parent, offlineResponse }) {
  const [camVersion, setCamVersion] = useState(' ');
  const [generatePopUp, setGeneratePopUp] = useState(false);
  const [downloadPopUp, setDownloadPopUp] = useState(false);
  const [sharePopUp, setSharePopUp] = useState(false);
  const [decisionEdit, setDecisionEdit] = useState(false);
  const [addPreference, setAddPreference] = useState(false);
  const [shareLetter, setShareLetter] = useState(false);
  const [selectWhat, setSelectWhat] = useState(' ');
  const [value, setValue] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [isActive, setActive] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [docPrevFlag, setDocPrevFlag] = useState({
    flag: false,
    srcPath: null,
    imgaltTag: null,
    contentType: null
  });
  const [approvButton, setApprovButton] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [masterTypeOptions, setMasterTypeOptions] = useState({
    leadSubmission: [],
    partnerLogin: [],
    dsaCodes: []
  });
  const [logoError, setLogoError] = useState(false);
  const [bankBranchId, setBankBranchId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { leadesItem } = location?.state || {};
  const { LoginData } = useLoginSelector();
  const { BranchBankDrop } = useLeadSelector();
  const { BankDropdownData, BankDrop } = useGlobalSelector();
  const [leadProfile, setLeadProfile] = useState(null);
  const [bankSearch, setBankSearch] = useState('');
  const { UserProfileData, RecommendedBankData } = useLoginModuleSelector();

  // console.log('leadesItem2222', leadesItem?.[0]?.leadId);

  // console.log('BranchBankDrop2222', BranchBankDrop);

  // console.log('offlineResponse222', offlineResponse);

  // Recommendation list - derive from RecommendedBankData
  const recommendedBanks = RecommendedBankData?.banks || [];

  const RECOMMENDED_BANK_CODES = [
    'HDFC',
    'ICICI',
    'SBI',
    'AXIS',
    'KOTAK',
    'PNB',
    'BANK_OF_BARODA',
    'IDFC',
    'BANDHAN',
    'UNION_BANK'
  ];

  const BranchRecordByBank = useCallback(() => {
    if (!bankBranchId) return;

    const credential = {
      bankId: bankBranchId
    };
    dispatch(getBranchRecordByBank(credential));
  }, [LoginData, bankBranchId]);

  useEffect(() => {
    BranchRecordByBank();
  }, [BranchRecordByBank]);

  // Filter (skip kpis as requested)
  const filteredBanks = recommendedBanks.filter((bank) => {
    if (!bankSearch) return true;
    const term = bankSearch.toString().toLowerCase();
    return (
      String(bank.bankId).toLowerCase().includes(term) ||
      (bank.bankName || '').toLowerCase().includes(term) ||
      (bank.bankCode || '').toLowerCase().includes(term) ||
      String(bank.loanAmount || '')
        .toLowerCase()
        .includes(term)
    );
  });

  const getLeadProfile = useCallback(() => {
    if (!leadesItem?.[0]?.leadId) return;
    dispatch(getLoginUserProfile(leadesItem?.[0]?.leadId));
  }, [LoginData]);

  const geRecommendedBank = useCallback(() => {
    if (!leadesItem?.[0]?.leadId) return;
    dispatch(getRecoRecommendedBank(leadesItem?.[0]?.leadId));
  }, [LoginData]);

  useEffect(() => {
    getLeadProfile();
  }, [getLeadProfile]);

  useEffect(() => {
    geRecommendedBank();
  }, [geRecommendedBank]);

  // useEffect(() => {
  //   UserProfileData();
  // }, [UserProfileData]);

  const getBankDsaDetails = (bankId, bankList = BankDropdownData?.banks) => {
    setBankBranchId(bankId);
    const bank = bankList?.find((b) => b.bankId === bankId);
    const res = bank?.dsaCodes || [];

    const dsaOptions = transformToSelectOptions(res?.map((code) => ({ label: code, value: code })));

    setMasterTypeOptions((prev) => ({
      ...prev,
      dsaCodes: dsaOptions // update state with dropdown options
    }));
  };

  const {
    handleSubmit: handleReduxSubmit,
    control,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema) // call from add edit prospect
  });

  // show edit card
  const handleEditCard = (event, fields) => {
    reset();
    setIsEdit(true);
  };

  // close edit card
  const handleCloseCard = (event) => {
    setIsEdit(false);
  };

  // edit submit api
  const onSubmit = useCallback(
    async (data) => {
      const finalData = {
        ...data,
        applicationId: leadesItem?.[0]?.applicationId,
        processingBankBranch: data?.branchByBankId,
        leadId: leadesItem?.[0]?.leadId,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId
      };

      try {
        const res = await dispatch(getLoginApproveProcess(finalData));
        if (res?.status === 'success') {
          handleCloseCard();
        }
      } catch (error) {
        console.error('Error submitting form:', error);
      }
    },
    [LoginData, leadesItem] // 🔹 depends on LoginData
  );

  // loan type & Bank Dropdown
  const getLoanTypeBankDropAPi = useCallback(() => {
    if (!LoginData) return;
    const data = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId,
      isWithCode: true
    };
    dispatch(getBankDropdownData(data));
  }, []);

  // master type data
  const MasterTypeApi = async () => {
    const subType = 'LEAD_SUBMISSION_TYPE';
    const partnerType = 'PARTNER_APPLICATION_LOGIN_TYPE';
    const leadSubmissionRes = await dispatch(getMasterListType(subType));
    const partnerLoginRes = await dispatch(getMasterListType(partnerType));

    const leadSubmissionOptions = transformToSelectOptions(
      leadSubmissionRes?.data?.masterTypes || [],
      'typeName',
      'typeId'
    );

    const partnerLoginOptions = transformToSelectOptions(
      partnerLoginRes?.data?.masterTypes || [],
      'typeName',
      'typeId'
    );

    setMasterTypeOptions((prev) => ({
      ...prev,
      leadSubmission: leadSubmissionOptions,
      partnerLogin: partnerLoginOptions
    }));
  };

  useEffect(() => {
    if (parent === 'login') {
      MasterTypeApi(); // master list
      getLoanTypeBankDropAPi(); // Bank Dropdown
    }
  }, [parent, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setOpenLoader(true);
    setTimeout(() => {
      setOpenLoader(false);
    }, 500);
  };

  const toggleClass = (box) => {
    setActive(box);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  const docPrevHandler = (type, srcData) => {
    if (type === 'open') {
      const responseData = JSON.parse(srcData);
      setDocPrevFlag({
        flag: true,
        srcPath: responseData.src,
        imgaltTag: responseData.alt,
        contentType: responseData.contentType
      });
    } else {
      setDocPrevFlag({ flag: false, srcPath: null, imgaltTag: null, contentType: null });
    }
  };

  // Helper function to generate document payloads
  const generateDocumentPayloads = (reviewCards) =>
    reviewCards?.flatMap((reviewCardsItem) =>
      reviewCardsItem.selectedJourneyReviewCards.flatMap((selectedJourneyReviewCardsItem) =>
        selectedJourneyReviewCardsItem.reviewCardFields.flatMap((reviewCardFieldsItem) => {
          const docMap = reviewCardFieldsItem?.cardDetail?.storedField?.documentMap;
          if (!docMap) return [];

          return Object.keys(docMap).map((documentMapItem) => {
            const path = docMap[documentMapItem]?.path ?? null;
            const fieldHeading =
              reviewCardFieldsItem?.reviewCardFieldHeading ??
              reviewCardFieldsItem?.cardDetail?.cardFieldMapping?.journeyCardFieldsMaster
                ?.fieldName;

            return {
              applicationDetailsId: path ? path.split('/')[path.split('/').length - 4] : null,
              cardDetailId: reviewCardFieldsItem.cardDetail.cardDetailId,
              faceValue: path ? path.split('/')[path.split('/').length - 1] : null,
              journeyCardId: reviewCardFieldsItem.cardDetail.journeyCardId,
              contentType: docMap[documentMapItem]?.contentType ?? null,
              documentName: documentMapItem === 'frontFace' ? fieldHeading : `${fieldHeading} Back`,
              path,
              status: null,
              verifiedStatus: null,
              type:
                selectedJourneyReviewCardsItem?.selectedJourneyCard?.cardPurpose?.cardPurposeName ??
                null
            };
          });
        })
      )
    );

  const loanProfileFields = useMemo(
    () => [
      {
        icon: <GiSwapBag className="viewLabelIcon" size={24} />,
        label: 'Loan Amount Requested',
        value: UserProfileData?.loanProfile?.loanAmountRequested
      },
      {
        icon: <InterestsIcon className="viewLabelIcon" size={24} />,
        label: 'Loan Type',
        value: UserProfileData?.loanProfile?.loanType
      },
      {
        icon: <DateRangeIcon className="viewLabelIcon" size={24} />,
        label: 'Tenure',
        value: UserProfileData?.loanProfile?.tenure
      },
      {
        icon: <GiSwapBag className="viewLabelIcon" size={24} />,
        label: 'Monthly Income',
        value: UserProfileData?.loanProfile?.monthlyIncome
      },
      {
        icon: <GiSwapBag className="viewLabelIcon" size={24} />,
        label: 'Annual Income',
        value: UserProfileData?.loanProfile?.annualIncome
      },
      {
        icon: <GiSwapBag className="viewLabelIcon" size={24} />,
        label: 'Monthly Obligation',
        value: UserProfileData?.loanProfile?.monthlyObligation
      },
      {
        icon: <MdCreditScore className="viewLabelIcon" size={24} />,
        label: 'FOIR',
        value: UserProfileData?.loanProfile?.foir
      },
      {
        icon: <InterestsIcon className="viewLabelIcon" size={24} />,
        label: 'Employment Type',
        value: UserProfileData?.loanProfile?.employmentType
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Residence Type',
        value: UserProfileData?.loanProfile?.residenceType
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Property Type',
        value: UserProfileData?.loanProfile?.propertyType
      },
      {
        icon: <GiSwapBag className="viewLabelIcon" size={24} />,
        label: 'Market Value',
        value: UserProfileData?.loanProfile?.marketValue
      }
    ],
    [UserProfileData?.loanProfile]
  );

  const applicantProfileFields = useMemo(
    () => [
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'Full Name',
        value: UserProfileData?.applicantProfile?.fullName
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'First Name',
        value: UserProfileData?.applicantProfile?.firstName
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'Middle Name',
        value: UserProfileData?.applicantProfile?.middleName
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'Last Name',
        value: UserProfileData?.applicantProfile?.lastName
      },
      {
        icon: <BsTelephone className="viewLabelIcon" size={24} />,
        label: 'Mobile',
        value: UserProfileData?.applicantProfile?.mobile
      },
      {
        icon: <HiOutlineMail className="viewLabelIcon" size={24} />,
        label: 'Email',
        value: UserProfileData?.applicantProfile?.email
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'Gender',
        value: UserProfileData?.applicantProfile?.gender
      },
      {
        icon: <DateRangeIcon className="viewLabelIcon" size={24} />,
        label: 'Date of Birth',
        value: UserProfileData?.applicantProfile?.dob
      },
      {
        icon: <PermContactCalendarIcon className="viewLabelIcon" size={24} />,
        label: 'Age',
        value: UserProfileData?.applicantProfile?.age
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'Marital Status',
        value: UserProfileData?.applicantProfile?.marriageType
      },
      {
        icon: <SupervisorAccountIcon className="viewLabelIcon" size={24} />,
        label: 'Is Co-Applicant',
        value:
          UserProfileData?.applicantProfile?.isCoApplicant === null
            ? null
            : UserProfileData?.applicantProfile?.isCoApplicant
            ? 'Yes'
            : 'No'
      }
    ],
    [UserProfileData?.applicantProfile]
  );

  const addressDetailsFields = useMemo(
    () => [
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Residence Address 1',
        value: UserProfileData?.address?.residenceAddress1
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Residence Address 2',
        value: UserProfileData?.address?.residenceAddress2
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Current Address 1',
        value: UserProfileData?.address?.curResidenceAddress1
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Current Address 2',
        value: UserProfileData?.address?.curResidenceAddress2
      },
      {
        icon: <SourceIcon className="viewLabelIcon" size={24} />,
        label: 'Pincode',
        value: UserProfileData?.address?.pincode
      },
      {
        icon: <SourceIcon className="viewLabelIcon" size={24} />,
        label: 'Current Pincode',
        value: UserProfileData?.address?.curPincode
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'District Id',
        value: UserProfileData?.address?.districtId
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Province Id',
        value: UserProfileData?.address?.provinceId
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Country Id',
        value: UserProfileData?.address?.countryId
      },
      {
        icon: <DateRangeIcon className="viewLabelIcon" size={24} />,
        label: 'Residence Since',
        value: UserProfileData?.address?.residenceSince
      }
    ],
    [UserProfileData?.address]
  );

  const kycDetailsFields = useMemo(
    () => [
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'PAN',
        value: UserProfileData?.kyc?.panId
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'PAN Verified',
        value: UserProfileData?.kyc?.isPanVerify
      },
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'Aadhar',
        value: UserProfileData?.kyc?.aadharId
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Aadhar Verified',
        value: UserProfileData?.kyc?.isAadharVerify
      },
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'GST',
        value: UserProfileData?.kyc?.gst
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'GST Verified',
        value: UserProfileData?.kyc?.isGstVerify
      },
      {
        icon: <FaRegUser className="viewLabelIcon" size={24} />,
        label: 'ITR Username',
        value: UserProfileData?.kyc?.itrUsername
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'ITR Verified',
        value: UserProfileData?.kyc?.isItrVerify
      },
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'Business PAN',
        value: UserProfileData?.kyc?.businessPan
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Business PAN Verified',
        value: UserProfileData?.kyc?.isBusinessPanVerify
      },
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'CIN',
        value: UserProfileData?.kyc?.cin
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'CIN Verified',
        value: UserProfileData?.kyc?.isCinVerify
      },
      {
        icon: <RiFileInfoLine className="viewLabelIcon" size={24} />,
        label: 'DIN',
        value: UserProfileData?.kyc?.din
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'DIN Verified',
        value: UserProfileData?.kyc?.isDinVerify
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Email Verified',
        value: UserProfileData?.kyc?.isEmailVerify
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Bank Statement Uploaded',
        value: UserProfileData?.kyc?.isBankStatement
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Bureau Verified',
        value: UserProfileData?.kyc?.isBureauVerify
      },
      {
        icon: <CheckCircleIcon className="viewLabelIcon" size={24} />,
        label: 'Auto Bureau Verified',
        value: UserProfileData?.kyc?.isBureauAutoVerify
      },
      {
        icon: <MdCreditScore className="viewLabelIcon" size={24} />,
        label: 'CIBIL Score',
        value: UserProfileData?.kyc?.cibilScore
      },
      {
        icon: <GiModernCity className="viewLabelIcon" size={24} />,
        label: 'Bureau Company',
        value: UserProfileData?.kyc?.bureauCompany
      }
    ],
    [UserProfileData?.kyc]
  );

  const workflowFields = useMemo(
    () => [
      {
        icon: <PermContactCalendarIcon className="viewLabelIcon" size={24} />,
        label: 'Lead Id',
        value: UserProfileData?.leadId
      },
      {
        icon: <PermContactCalendarIcon className="viewLabelIcon" size={24} />,
        label: 'Prospect Id',
        value: UserProfileData?.prospectId
      },
      {
        icon: <StayCurrentPortraitIcon className="viewLabelIcon" size={24} />,
        label: 'Status',
        value: UserProfileData?.status
      },
      {
        icon: <StayCurrentPortraitIcon className="viewLabelIcon" size={24} />,
        label: 'Current Stage',
        value: UserProfileData?.workflow?.currentStageName
      },
      {
        icon: <StayCurrentPortraitIcon className="viewLabelIcon" size={24} />,
        label: 'Current Stage Id',
        value: UserProfileData?.workflow?.currentStageId
      },
      {
        icon: <StayCurrentPortraitIcon className="viewLabelIcon" size={24} />,
        label: 'Current Status',
        value: UserProfileData?.workflow?.currentStatus
      },
      {
        icon: <AssignmentIndIcon className="viewLabelIcon" size={24} />,
        label: 'Assigned To',
        value: UserProfileData?.workflow?.assignedTo
      },
      {
        icon: <AssignmentIndIcon className="viewLabelIcon" size={24} />,
        label: 'Assigned To Name',
        value: UserProfileData?.workflow?.assignedToName
      },
      {
        icon: <DateRangeIcon className="viewLabelIcon" size={24} />,
        label: 'Assigned On',
        value: UserProfileData?.workflow?.assignedOn
      },
      {
        icon: <UpdateIcon className="viewLabelIcon" size={24} />,
        label: 'Last Updated On',
        value: UserProfileData?.workflow?.lastUpdatedOn
      }
    ],
    [
      UserProfileData?.workflow,
      UserProfileData?.leadId,
      UserProfileData?.prospectId,
      UserProfileData?.status
    ]
  );

  return (
    <Box>
      <Loader openLoader={openLoader} />
      <Box sx={{ mb: 3 }}>
        <Tabs value={value} onChange={handleChange} sx={pillTabsSx}>
          {[
            { label: 'User Profile', icon: <PersonIcon /> },
            { label: 'Recommendation List', icon: <ListAltIcon /> }
          ].map((tab, tIdx) => (
            <Tab
              key={tIdx}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              disableRipple
              {...a11yProps(tIdx)}
            />
          ))}
        </Tabs>
      </Box>

      {/* tab panel first start */}
      <TabPanel value={value} index={0}>
        {parent === 'login' && (
          <Box display="flex" justifyContent="flex-end" mb={2.5}>
            <Button
              variant="contained"
              startIcon={<MdCheckBox size={20} />}
              onClick={() => handleEditCard()}
              disabled={leadesItem?.[0]?.logInStatusName !== 'New'}
              sx={{
                bgcolor: '#0284c7',
                color: '#ffffff',
                borderRadius: '10px',
                fontWeight: 700,
                fontSize: '13px',
                textTransform: 'none',
                py: 1,
                px: 2.5,
                boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' },
                '&.Mui-disabled': {
                  bgcolor: '#e2e8f0',
                  color: '#94a3b8'
                }
              }}
            >
              Approve for Processing
            </Button>
          </Box>
        )}
        <Box>
          {!UserProfileData ? (
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              No profile data available.
            </Typography>
          ) : (
            <Grid container spacing={3}>
              <ViewCardComponent title="Loan Profile" fields={loanProfileFields || []} />
              <ViewCardComponent title="Applicant Profile" fields={applicantProfileFields || []} />
              <ViewCardComponent title="Address Details" fields={addressDetailsFields || []} />
              <ViewCardComponent title="KYC Details" fields={kycDetailsFields || []} />
              <ViewCardComponent title="Workflow" fields={workflowFields || []} />
            </Grid>
          )}
        </Box>
      </TabPanel>
      {/* tab panel second start */}
      <TabPanel value={value} index={1}>
        <Grid container spacing={3}>
          <ViewCardComponent title="Recommended Bank List">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              flexWrap="wrap"
              gap={2}
              mb={2.5}
              mt={1}
            >
              <Typography variant="body2" sx={{ color: '#64748b', fontSize: 13 }}>
                Banks shortlisted as per your internal recommendation logic.
              </Typography>

              <SearchStyle
                value={bankSearch}
                onChange={(e) => setBankSearch(e.target.value)}
                placeholder="Search bank list"
                sx={{ width: 240 }}
                classes={{ root: 'searchHolder', input: 'searchInput' }}
                startAdornment={
                  <InputAdornment position="start">
                    <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                }
              />
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Scrollbar style={{ maxHeight: 420 }}>
              <TableContainer
                sx={{
                  border: '1px solid #e2e8f0',
                  borderRadius: '12px',
                  overflow: 'hidden'
                }}
              >
                <Table size="small" stickyHeader>
                  <TableHead>
                    <TableRow sx={{ bgcolor: '#f8fafc' }}>
                      <StyledTableCell>Bank Name</StyledTableCell>
                      <StyledTableCell align="right">Loan Amount</StyledTableCell>
                      <StyledTableCell align="right">Interest Rate</StyledTableCell>
                      <StyledTableCell align="right">EMI</StyledTableCell>
                      <StyledTableCell align="right">Tenure</StyledTableCell>
                      <StyledTableCell align="right">Processing Fees</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredBanks.map((bank) => (
                      <StyledTableRow key={bank.bankId} hover>
                        <StyledTableCell width={160}>
                          <Box display="flex" alignItems="center" gap={1.5}>
                            <BankLogo bankName={bank.bankName} />
                            <Typography
                              variant="subtitle2"
                              sx={{ fontSize: '13px', fontWeight: 700, color: '#0f172a' }}
                            >
                              {bank.bankName}
                            </Typography>
                          </Box>
                        </StyledTableCell>
                        <StyledTableCell align="right" sx={{ color: '#0f172a', fontWeight: 600 }}>
                          {bank.loanAmount ?? 'NA'}
                        </StyledTableCell>
                        <StyledTableCell align="right" sx={{ color: '#64748b' }}>
                          {bank.interestRate ?? 'NA'}
                        </StyledTableCell>
                        <StyledTableCell align="right" sx={{ color: '#64748b' }}>
                          {bank.emi ?? 'NA'}
                        </StyledTableCell>
                        <StyledTableCell align="right" sx={{ color: '#64748b' }}>
                          {bank.tenure ?? 'NA'}
                        </StyledTableCell>
                        <StyledTableCell align="right" sx={{ color: '#64748b' }}>
                          {bank.processingFees ?? 'NA'}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}

                    {filteredBanks.length === 0 && (
                      <StyledTableRow>
                        <StyledTableCell colSpan={6} align="center">
                          <Typography variant="body2" color="text.secondary">
                            No banks found for “{bankSearch}”.
                          </Typography>
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>

            {/* small footer showing total count if available from API */}
            <Box mt={2} display="flex" justifyContent="space-between">
              <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
                Total Banks: {RecommendedBankData?.totalBanks ?? recommendedBanks.length}
              </Typography>
              <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>
                Displayed: {filteredBanks.length}
              </Typography>
            </Box>
          </ViewCardComponent>
        </Grid>
      </TabPanel>

      <CustomDialog
        showCloseIcon
        open={isEdit}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleCloseCard();
          }
        }}
        title="Submission"
        content={
          <Box mb={3}>
            <form id="EditLoanRequirementForm" onSubmit={handleReduxSubmit(onSubmit)}>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <CustomSelect
                    name="submittedToBankId"
                    label="Bank Name"
                    control={control}
                    errors={errors}
                    options={BankDrop || []}
                    isRequired
                    onChange={(event, val) => {
                      getBankDsaDetails(val);
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="branchByBankId"
                    label="Branch"
                    control={control}
                    errors={errors}
                    options={BranchBankDrop || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="submissionModeTypeId"
                    label="Mode of Submission"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.leadSubmission || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="loginTypeId"
                    label="Login Type"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.partnerLogin || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelect
                    name="dsaLoginCode"
                    label="Login Code/DSA Code"
                    control={control}
                    errors={errors}
                    options={masterTypeOptions?.dsaCodes || []}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="processingCenterName"
                    label="Processing Center"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="bankContactPersonName"
                    label="Bank Contact Person"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomInput
                    name="bankContactPersonMobile"
                    label="Contact Person Mobile"
                    control={control}
                    errors={errors}
                    isRequired
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomInput
                    name="submissionComments"
                    label="Comments"
                    type="textarea"
                    rows={2}
                    control={control}
                    errors={errors}
                    multiline
                    isRequired
                  />
                </Grid>
              </Grid>
            </form>
          </Box>
        }
        actions={
          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              sx={{
                borderRadius: '8px',
                textTransform: 'none',
                borderColor: '#e2e8f0',
                color: '#64748b',
                '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
              }}
              onClick={handleCloseCard}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              form="EditLoanRequirementForm"
              variant="contained"
              sx={{
                bgcolor: '#0284c7',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                boxShadow: '0 4px 14px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              Save
            </Button>
          </Box>
        }
      />
      <Dialog
        className="PopupBox"
        open={docPrevFlag.flag}
        onClose={() => docPrevHandler('close', '')}
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="popupHeading">
          <Typography variant="h6" className="popupTitle">
            {docPrevFlag.contentType === 'content'
              ? 'Document Size Error '
              : docPrevFlag.contentType === 'validation'
              ? 'Required Fields'
              : 'Document Preview'}
          </Typography>
          <IconButton onClick={() => docPrevHandler('close', '')} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="PopupContent">
          <DialogContentText>
            {docPrevFlag.contentType === 'content' || docPrevFlag.contentType === 'validation' ? (
              docPrevFlag.imgaltTag
            ) : docPrevFlag.contentType === 'application/pdf' ? (
              <Document
                file={docPrevFlag.srcPath}
                onLoadSuccess={(numPages) => onDocumentLoadSuccess(numPages)}
              >
                <Pages pageNumber={pageNumber} />
              </Document>
            ) : (
              <img src={docPrevFlag.srcPath} alt={docPrevFlag.imgaltTag} />
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="mainBtn" onClick={() => docPrevHandler('close', '')}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
export default ApplicationView;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ paddingTop: '1rem' }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
